// ListNoti.jsx
import React from "react";
import danger from "../icons/warning/danger.svg";

const ListNoti = ({ notice, isUnread, onClick, formatRelativeTime }) => {
  const createdAt = notice.created_at;

  return (
    <li
      className={`px-[16px] rounded-[12px] active:bg-surface-strong/5 cursor-pointer ${
        isUnread ? "bg-surface-light-subtle py-[12px]" : "bg-surface-light-white py-[8px]"
      }`}
      onClick={() => onClick(notice)}
    >
      <p
        className={`text-b1 line-clamp-2 ${
          isUnread ? "text-text-subtle" : "text-text-subtler"
        }`}
      >
        {notice.notice_title}
      </p>

      <p
        className={`
          pt-[8px]
          text-c2
          flex items-center
          gap-[4px]
          ${isUnread ? "text-text-subtler" : "text-text-disabled"}
        `}
      >
        {formatRelativeTime(createdAt)}
        {isUnread && (
          <img
            src={danger}
            alt="읽지 않은 알림"
          />
        )}
      </p>
    </li>
  );
};

export default ListNoti;
